<span class="d-xs-inline d-sm-none">{{ label | titlecase}}: </span>
{{party?.quoted_time | trDateFormat:'h:mm a': timezone }}
<span class="d-xs-inline d-sm-block">
  <span [ngClass]="timeDeltaNgClass(party?.quoted_time)">
    ({{ (party?.quoted_time - now) | trTimeDelta}})
  </span>
</span>
